import { Module } from 'wrapper6'

const $ = jQuery

export default class EnhancedConversions extends Module {
  ready (app) {
    const types = [
      'email',
      'phone',
    ]

    types.forEach((type) => {
      this.addHiddenField(type)

      $(`input[name*="${type}"]`).on('input', (event) => {
        this.updateConversion(type, event.target.value)
      })
    })
  }

  updateConversion (type, value) {
    if (type === 'email') {
      this.updateEmailValue(value)
    } else if (type === 'phone') {
      this.updatePhoneValue(value)
    }
  }

  updateEmailValue (value) {
    this.normalizeAndHashEmailAddress(value).then((hash) => {
      $(this.getConversionSelector('email')).text(hash)
    })
  }

  updatePhoneValue (value) {
    let normalizedPhone = value;

    if(normalizedPhone.length === 8) {
      normalizedPhone = `45${normalizedPhone}`
    }

    this.normalizeAndHash(normalizedPhone).then((hash) => {
      $(this.getConversionSelector('phone')).text(hash)
    })
  }

  getConversionSelector (type) {
    return `#${this.getConversionSelectorName(type)}`
  }

  getConversionSelectorName (type) {
    return `enhanced-conversion-${type}`
  }

  addHiddenField (type) {
    $('<div>', {
      id: this.getConversionSelectorName(type),
      'style': 'display: none;',
    }).appendTo('body')
  }

  normalizeAndHash (value) {
    return this.hash(value.toLowerCase().trim())
  }

  async hash (message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message)

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer))

    // convert bytes to hex string
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
  }

  /**
   * Js version of https://developers.google.com/google-ads/api/docs/conversions/enhance-conversions#php
   */
  normalizeAndHashEmailAddress (email) {
    let normalizedEmail = email.toLowerCase()
    let emailParts = normalizedEmail.split('@')

    const emailRegex = new RegExp('/^(gmail|googlemail)\.com\s*/')

    if (emailParts.length > 1 && emailParts[1].match(emailRegex)) {
      // Removes any '.' characters from the portion of the email address before the domain
      // if the domain is gmail.com or googlemail.com.
      emailParts[0] = emailParts[0].replace('.', '')
      normalizedEmail = `${emailParts[0]}@${emailParts[1]}`
    }

    return this.normalizeAndHash(normalizedEmail)
  }
}